import React, { useRef } from 'react'
import { ChevronUp } from '../icons/icons'
import {
    ChevronWrapper,
    FilterClickable,
    FilterHeader,
    FilterHeading,
    FilterSelectedValue,
    TitleAndBadgeWrapper,
    TitleWrapper,
} from './expandable-filter-header.styles'
import { FilterTitle } from '../expandable-filter/expandable-filter.styles'
import { useIsLeisureOrTPF } from '../../utils/channel-utilities'

interface ExpandableFilterHeaderProps {
    className: string
    icon: React.ReactNode
    title: string
    selectedValuesSummary?: string | null
    isOpen?: boolean
    onClick: React.MouseEventHandler<HTMLButtonElement>
    disabled: boolean
    badge?: React.ReactNode
    alwaysOpen: boolean
}

export const ExpandableFilterHeader = ({
    className,
    icon,
    title,
    selectedValuesSummary,
    isOpen = false,
    onClick,
    disabled,
    badge = null,
    alwaysOpen,
}: ExpandableFilterHeaderProps) => {
    const openFilterRef = useRef<HTMLDivElement>(null)
    const chevronTitle = isOpen ? 'Close filter' : 'Open filter'
    const isLeisureOrTPF = useIsLeisureOrTPF()

    return (
        <FilterClickable
            onClick={onClick}
            withDisplayValue={!!selectedValuesSummary}
            isFilterOpen={isOpen}
            name={className}
            data-testid={`${className}-facet-group`}
            shouldGreyOut={disabled}
            disabled={disabled && !isOpen}
            alwaysOpen={alwaysOpen}
        >
            <FilterHeader ref={openFilterRef}>
                <FilterHeading>
                    <TitleWrapper>
                        {icon}
                        <TitleAndBadgeWrapper>
                            <FilterTitle as="p">{title}</FilterTitle>
                            {badge}
                        </TitleAndBadgeWrapper>
                    </TitleWrapper>
                    {!isOpen && selectedValuesSummary ? (
                        <FilterSelectedValue as="p" $isLeisureOrTPF={isLeisureOrTPF}>
                            {selectedValuesSummary}
                        </FilterSelectedValue>
                    ) : null}
                </FilterHeading>
                {!alwaysOpen ? (
                    <ChevronWrapper isFilterOpen={isOpen} shouldGreyOut={disabled} disabled={disabled && !isOpen}>
                        <ChevronUp name={chevronTitle} size="medium" />
                    </ChevronWrapper>
                ) : null}
            </FilterHeader>
        </FilterClickable>
    )
}
